// @ts-nocheck
import { h } from "preact";
import { Button, Modal } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { useForm } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { FORM_MAINTENANCE_CONFIRM_GET_JOB } from "../../constants/forms";
import { IPropsModal } from "../../interface/modal";
import {
  ContainerConfirmGetJob,
  ContainerModalFooterSingle,
} from "../../styled";
import { Text } from "../../../../components/text";
import { useSelector } from "react-redux";
import { useMessage } from "../../../../hooks/useMessage";
import { POST, PRODUCT_CONFIRM } from "../../../../services";
import { convertDateTime } from "../../../../functions";
import { DEFAULT_STATE } from "../../constants/default-status";

export const ModalConfirmGetJob = forwardRef<any, IPropsModal>((props, ref) => {
  const userState: any = useSelector((state: IAuthState) => state.auth.user);
  const { onCallbackEdit, onBeforeConfirm } = props;
  const { openMessage } = useMessage();
  const [visible, setVisible] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [MainId, setMaineId] = useState("");
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: DEFAULT_STATE,
  });

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  useImperativeHandle(ref, () => ({
    async openModal(e: any) {
      try {
        for (const key in e) {
          const element = e[key];
          if (key in DEFAULT_STATE) {
            setValue(key as keyof typeof DEFAULT_STATE, element);
          }
        }
        setValue("main_confirm_worker", userState.fullName);
        setValue("main_confirm_start_date", convertDateTime(e.createDate));
        setDeviceId(e.deviceId);
        setMaineId(e.maintainId);
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  const onConfirm = async () => {
    try {
      setLoading(true);
      onBeforeConfirm && await onBeforeConfirm();
      const { maintainId, main_confirm_remark } = getValues();
      const res = await POST(PRODUCT_CONFIRM, {
        maintainId,
        remark: main_confirm_remark,
      });
      if (!res.success) {
        return openMessage("error", "รับงานไม่สำเร็จ");
      }
      setLoading(false);
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    }
  };

  return (
    <Modal
      centered
      width={650}
      title={
        (
          <Text size={"L"} text={`คอนเฟิร์มรับงาน #${MainId}`} bold />
        ) as React.ReactNode
      }
      transitionName={''}
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      confirmLoading={loading}
      onCancel={() => setVisible(false)}
      footer={[
        <ContainerModalFooterSingle key="1">
          <Button
            loading={loading}
            type="primary"
            onClick={handleSubmit(onConfirm)}
          >
            รับงาน
          </Button>
        </ContainerModalFooterSingle>,
      ]}
    >
      <ContainerConfirmGetJob>
        <Text size={"S"} text={`หมายเลขเครืองตัด: ${deviceId}`} />
      </ContainerConfirmGetJob>
      <BaseForm
        control={control}
        forms={FORM_MAINTENANCE_CONFIRM_GET_JOB()}
        setValue={setValue}
        getValues={getValues}
      />
    </Modal>
  );
});
